import React, { Component } from 'react';
import * as $ from 'jquery';
import { translate } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import Summary from './Summary';
import Payment from './Payment';
import axios from 'axios';
import SuccessDialog from './SuccessDialog.js';

let cancelToken;
let state;
let tokenSession;

class PaymentContainerStore extends Component {


    getInitState = () => {
        return {
            cardCvc: "",
            cardMonth: "",
            cardName: "",
            cardNumber: "",
            cardYear: "",
            city: "",
            country: "",
            error: "",
            isPaying: false,
            neighborhood: "",
            paymentDetails: null,
            po: "",
            promocode: "",
            promocodeError: "",
            reservationOccupancy: "",
            reservationTitle: "",
            state: "",
            number: "",
            street: "",
            RoomBook: null,
            email: "",
            name: "",
            lastname: "",
            phone: "",
            sala: null,
        };
    }

    constructor(props) {
        super(props);
        if (tokenSession !== props.getTokenSession()) {
            state = this.getInitState();
        }
        this.state = state;
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
    }

    componentDidMount() {
        this.reload();
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
        state = this.state;
        tokenSession = this.props.getTokenSession();
    }

    reload = () => {
        if (this.props.match.params.reservationsid) {

            this.getPaymentData({
                token_id: this.props.getTokenId(),
                token_session: this.props.getTokenSession(),
                reservation_id: this.props.match.params.reservationsid,
            });


            this.getBooK({
                token_id: this.props.getTokenId(),
                token_session: this.props.getTokenSession(),
                reservation_id: this.props.match.params.reservationsid,
            });
        }
    }

    getBooK = (params) => {
        this.props.post_store(
            "/getBook",
            params,
            (response) => this.didGetBook(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getPaymentData = (params) => {
        this.props.post_store(
            "/getPayment",
            params,
            (response) => this.didPaymentData(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getRoom = (params) => {
        this.props.post_store(
            "/getRoom",
            params,
            (response) => this.didGetSalas(response),
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    }

    didGetSalas = (response) => {
        this.setState({ sala: response })
    }

    getConekta = (params) => {
        this.props.post(
            "/getConnekta",
            params,
            (response) => this.didRazonSocial(response),
            (error) => this.didRazonSocialError(error),
            cancelToken
        );
    }

    payRoom = (params) => {
        this.props.post_store(
            "/payRoom",
            params,
            (response) => this.didPayRoom(response),
            (error, _, conekta_msj, msg) => {
                localStorage.removeItem("params");
                this.setState({ isPaying: false });
                if (conekta_msj) { alert(msg); } else { this.handleErrorResponse(error); }
            },
            cancelToken,
            () => this.setState({ isPaying: false })
        );
    }

    didGetBook = (response) => {
        this.setState({ RoomBook: response })

        this.getRoom({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            room_id: this.state.RoomBook.sala_id,
            ingles: false,
        });

    }

    didPaymentData = (response) => {
        this.setState({ paymentDetails: response })
    }

    didPayRoom = (response) => {
        $('#btnSuccess').click();
    }

    handleErrorResponse = (error) => {
        alert(error)
    }

    handleCardName = (event) => {
        this.setState({ cardName: event.target.value });
    }

    handleCardNumber = (event) => {
        this.setState({ cardNumber: event.target.value });
    }

    handleCardMonth = (event) => {
        this.setState({ cardMonth: event.target.value });
    }

    handleCardYear = (event) => {
        this.setState({ cardYear: event.target.value });
    }

    handleCardCvc = (event) => {
        this.setState({ cardCvc: event.target.value });
    }

    handleStreetChange = (event) => {
        this.setState({ street: event.target.value });
    }

    handleNeighborhoodChange = (event) => {
        this.setState({ neighborhood: event.target.value });
    }

    handlePoChange = (event) => {
        this.setState({ po: event.target.value });
    }

    handleCityChange = (event) => {
        this.setState({ city: event.target.value });
    }

    handleStateChange = (event) => {
        this.setState({ state: event.target.value });
    }

    handleCountryChange = (event) => {
        this.setState({ country: event.target.value });
    }

    handleClearError = () => {
        this.setState({ error: "" });
    }

    handleEmailChange = (event) => {
        this.setState({ email: event.target.value });
    }

    handleLastnameChange = (event) => {
        this.setState({ lastname: event.target.value });
    }

    handleNameChange = (event) => {
        this.setState({ name: event.target.value });
    }

    handleReservationTitle = (event) => {
        this.setState({ reservationTitle: event.target.value });
    }

    handlePaymentSubmit = (event) => {
        event.preventDefault();
        const params = {
            email: this.state.email,
            name: this.state.name,
            lastname: this.state.lastname,
            phone: this.state.phone,
            reservation_id: this.state.RoomBook.id,
            reservation_occupancy: this.state.reservationOccupancy,
            reservation_title: this.state.reservationTitle,
            razon_social: this.state.sala.centro_razonsociale_id,
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession()
        };
        localStorage.setItem("params", JSON.stringify(params));
        const callback = () => { this.handlePaymentConekta(params); }

        this.setState({ isPaying: true }, callback);
    }

    handlePaymentConekta = (params) => {
        const onSuccess = (token) => this.payRoom(
            Object.assign({},
                params,
                { token_conekta: token.id })
        );

        const onError = (error) => this.setState({
            error: error.message_to_purchaser,
            isPaying: false
        });

        window.Conekta.Token.create(
            this.getTokenParams(),
            (token) => onSuccess(token),
            (error) => onError(error)
        );
    }

    getTokenParams = () => {
        return {
            "card": {
                "number": this.state.cardNumber.trim(),
                "name": this.state.cardName.trim(),
                "exp_year": "20" + this.state.cardYear.trim(),
                "exp_month": this.state.cardMonth.trim(),
                "cvc": this.state.cardCvc.trim(),
                "address": {
                    "street1": this.state.street.trim(),
                    "street2": this.state.neighborhood.trim(),
                    "city": this.state.city.trim(),
                    "state": this.state.state.trim(),
                    "zip": this.state.po.trim(),
                    "country": this.state.country.trim()
                }
            }
        }
    }

    handleReservationOccupancy = (event) => {
        this.setState({ reservationOccupancy: event.target.value });
    }

    handlePhoneChange = (event) => {
        this.setState({ phone: event.target.value });
    }


    renderSuccessDialog = () => {
        return (
          <SuccessDialog />
        );
      }

    renderSummary = () => {
        return (
            <Summary
                RoomBook={this.state.RoomBook}
                paymentDetails={this.state.paymentDetails}
                count={this.state.sala}
            />
        );
    }

    renderPayment = () => {
        return (
            <Payment
                cardMonth={this.state.cardMonth}
                cardName={this.state.cardName}
                cardNumber={this.state.cardNumber}
                cardCvc={this.state.cardCvc}
                cardYear={this.state.cardYear}
                city={this.state.city}
                country={this.state.country}
                error={this.state.error}
                handleCardCvc={this.handleCardCvc}
                handleCardMonth={this.handleCardMonth}
                handleCardName={this.handleCardName}
                handleCardNumber={this.handleCardNumber}
                handleCardYear={this.handleCardYear}
                handleCityChange={this.handleCityChange}
                handleClearError={this.handleClearError}
                handleCountryChange={this.handleCountryChange}
                handleEmailChange={this.handleEmailChange}
                handleLastnameChange={this.handleLastnameChange}
                handleNameChange={this.handleNameChange}
                handleNeighborhoodChange={this.handleNeighborhoodChange}
                handlePaymentSubmit={this.handlePaymentSubmit}
                handleReservationOccupancy={this.handleReservationOccupancy}
                handlePhoneChange={this.handlePhoneChange}
                handlePoChange={this.handlePoChange}
                handleReservationTitle={this.handleReservationTitle}
                handleStateChange={this.handleStateChange}
                handleStreetChange={this.handleStreetChange}
                isPaying={this.state.isPaying}
                neighborhood={this.state.neighborhood}
                po={this.state.po}
                reservationOccupancy={this.state.reservationOccupancy}
                reservationTitle={this.state.reservationTitle}
                state={this.state.state}
                street={this.state.street}
                user={this.state.user} />
        );
    }

    render() {
        const { t } = this.props;
        return (
            <div className="content-resvations">
                <div className="container-resvations-title">
                    <div className="row">
                        <h2 className="page-header">{t('dashboard.reservations.heading')}</h2>
                    </div>
                </div>
                <div className="container-resvations">
                    <div className="row">
                        <div className="col-md-6 col-md-push-6 col-lg-4 col-lg-push-8">
                            {this.state.RoomBook ? this.renderSummary() : null}
                        </div>
                        <div className="col-md-6 col-md-pull-6 col-lg-8 col-lg-pull-4">
                            {this.renderPayment()}
                            {this.renderSuccessDialog()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default compose(
    translate('common'),
    withRouter
)(PaymentContainerStore);



// WEBPACK FOOTER //
// ./src/dashboard/store/Payment/PaymentContainer.js